/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";
import * as XLSX from "xlsx";

const MODULLER = [
    { key: "dip_tara",        label: "📊 Dip Tarama",            aktif: true  },
    { key: "likidite_tara",   label: "🌊 Likidite Tarama",       aktif: true  },
    { key: "fvg_tara",        label: "📈 FVG Tarama",            aktif: true  },
    { key: "capa_tara",       label: "⚓ Çapa Noktası Tarama",   aktif: true  },
    { key: "msb_tara",        label: "📐 MSB Tarama",            aktif: true  },
    { key: "ote_tara",        label: "🎯 OTE Tarama",            aktif: true  },
    { key: "obbb_tara",       label: "🧱 OB & BB Tarama",        aktif: true  },
    { key: "inducement_tara", label: "🎣 IDM Tarama",            aktif: true  },
    { key: "pd_tara",         label: "⚖️ P/D Zone Tarama",       aktif: true  },
    { key: "smt_tara",        label: "🔀 SMT Tarama",            aktif: true  },
    { key: "killzone_tara",   label: "⏰ Killzone Tarama",       aktif: true  },
    { key: "topdown_tara",    label: "🎯 Topdown Cascade",       aktif: true  },
    { key: "hacim_profili",   label: "📊 Hacim Profili Tarama",  aktif: true  },
    { key: "hacim_akisi",     label: "📊 Hacim Akışı Tarama",    aktif: true  },
    { key: "divergence",      label: "📐 Divergence Tarama",     aktif: true  },
    { key: "coklu_tara",      label: "🔗 Çoklu Tarama",          aktif: true  },
    { key: "islem_planlama",  label: "📋 İşlem Planlama",        aktif: true  },
    { key: "puanlama_tara",   label: "⭐ Puanlama & Tahmin",     aktif: true  },
    { key: "karar_motoru",    label: "🧭 Karar Motoru",          aktif: true  },
    { key: "birlesik_skor",   label: "🎯 Birleşik Skor",         aktif: true  },
];

// Sonuç listesi filtre kartı: her modülün hangi alanlara göre filtrelenebileceği
const MODUL_FILTRE_ALANLARI = {
    dip_tara: [
        { alan: "durum",       etiket: "DURUM",       renk: "#3b82f6" },
        { alan: "tolerans",    etiket: "TOLERANS",    renk: "#eab308", onEk: "%" },
        { alan: "para_birimi", etiket: "PARA BİRİMİ", renk: "#a78bfa" },
    ],
    likidite_tara: [
        { alan: "sweep_tipi",     etiket: "SWEEP TİPİ",     renk: "#3b82f6" },
        { alan: "kalite",         etiket: "KALİTE",         renk: "#eab308" },
        { alan: "para_birimi",    etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
        { alan: "tarama_periyot", etiket: "TARAMA PERİYOT", renk: "#0d9488" },
    ],
    fvg_tara: [
        { alan: "fvg_tip",        etiket: "FVG TİPİ",       renk: "#3b82f6" },
        { alan: "fvg_durumu",     etiket: "FVG DURUMU",     renk: "#eab308" },
        { alan: "bpr_durumu",     etiket: "BPR DURUMU",     renk: "#16a34a" },
        { alan: "tarama_periyot", etiket: "TARAMA PERİYOT", renk: "#0d9488" },
        { alan: "para_birimi",    etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
    ],
    capa_tara: [
        { alan: "fvg_tip",       etiket: "FVG TİPİ",       renk: "#3b82f6" },
        { alan: "temas_sayisi",  etiket: "TEMAS SAYISI",   renk: "#eab308" },
        { alan: "capa_durum",    etiket: "ÇAPA DURUMU",    renk: "#16a34a" },
        { alan: "para_birimi",   etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
    ],
    msb_tara: [
        { alan: "msb_tipi",       etiket: "MSB TİPİ",       renk: "#3b82f6" },
        { alan: "guclu_kirilim",  etiket: "GÜÇLÜ KIRILIM",  renk: "#16a34a" },
        { alan: "tarama_periyot", etiket: "TARAMA PERİYOT", renk: "#0d9488" },
        { alan: "para_birimi",    etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
    ],
    ote_tara: [
        { alan: "ote_tipi",       etiket: "OTE TİPİ",       renk: "#3b82f6" },
        { alan: "durum",          etiket: "DURUM",          renk: "#eab308" },
        { alan: "tarama_periyot", etiket: "TARAMA PERİYOT", renk: "#0d9488" },
        { alan: "para_birimi",    etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
    ],
    obbb_tara: [
        { alan: "ob_tipi",        etiket: "OB/BB TİPİ",     renk: "#3b82f6" },
        { alan: "displacement",   etiket: "DISPLACEMENT",   renk: "#eab308" },
        { alan: "fvg_onayi",      etiket: "FVG ONAYI",      renk: "#16a34a" },
        { alan: "guc",            etiket: "GÜÇ",            renk: "#f59e0b" },
        { alan: "tarama_periyot", etiket: "TARAMA PERİYOT", renk: "#0d9488" },
        { alan: "para_birimi",    etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
    ],
    inducement_tara: [
        { alan: "idm_tipi",       etiket: "IDM TİPİ",       renk: "#3b82f6" },
        { alan: "sweep_durumu",   etiket: "SWEEP DURUMU",   renk: "#eab308" },
        { alan: "durum",          etiket: "DURUM",          renk: "#f59e0b" },
        { alan: "tarama_periyot", etiket: "TARAMA PERİYOT", renk: "#0d9488" },
        { alan: "para_birimi",    etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
    ],
    pd_tara: [
        { alan: "bolge",          etiket: "BÖLGE",          renk: "#3b82f6" },
        { alan: "yon_onerisi",    etiket: "YÖN ÖNERİSİ",    renk: "#eab308" },
        { alan: "tarama_periyot", etiket: "TARAMA PERİYOT", renk: "#0d9488" },
        { alan: "para_birimi",    etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
    ],
    smt_tara: [
        { alan: "smt_tipi",       etiket: "SMT TİPİ",       renk: "#3b82f6" },
        { alan: "guc",            etiket: "GÜÇ",            renk: "#eab308" },
        { alan: "tarama_periyot", etiket: "TARAMA PERİYOT", renk: "#0d9488" },
        { alan: "para_birimi",    etiket: "PARA BİRİMİ",    renk: "#a78bfa" },
    ],
    killzone_tara: [
        { alan: "killzone",     etiket: "KILLZONE",     renk: "#3b82f6" },
        { alan: "yapi_tipi",    etiket: "YAPI TİPİ",    renk: "#eab308" },
        { alan: "hacim_onayi",  etiket: "HACİM ONAYI",  renk: "#16a34a" },
        { alan: "sinif",        etiket: "SINIF",        renk: "#f59e0b" },
        { alan: "para_birimi",  etiket: "PARA BİRİMİ",  renk: "#a78bfa" },
    ],
    coklu_tara: [
        { alan: "moduller",    etiket: "MODÜLLER",    renk: "#3b82f6" },
        { alan: "para_birimi", etiket: "PARA BİRİMİ", renk: "#a78bfa" },
    ],
    topdown_tara: [
        { alan: "trend",       etiket: "TREND",       renk: "#3b82f6" },
        { alan: "sweep_tipi",  etiket: "SWEEP TİPİ",  renk: "#eab308" },
        { alan: "para_birimi", etiket: "PARA BİRİMİ", renk: "#a78bfa" },
    ],
    islem_planlama: [
        { alan: "yon",         etiket: "YÖN",         renk: "#3b82f6" },
        { alan: "durum",       etiket: "DURUM",       renk: "#eab308" },
        { alan: "islem_tipi",  etiket: "İŞLEM TİPİ",  renk: "#16a34a" },
        { alan: "para_birimi", etiket: "PARA BİRİMİ", renk: "#a78bfa" },
    ],
    puanlama_tara: [
        { alan: "guven_skoru", etiket: "GÜVEN SKORU", renk: "#3b82f6" },
        { alan: "yon",         etiket: "YÖN",         renk: "#eab308" },
        { alan: "vade",        etiket: "VADE",        renk: "#16a34a" },
        { alan: "para_birimi", etiket: "PARA BİRİMİ", renk: "#a78bfa" },
    ],
    karar_motoru: [
        { alan: "giris_skoru", etiket: "GİRİŞ SKORU", renk: "#3b82f6" },
        { alan: "karar",       etiket: "KARAR",       renk: "#eab308" },
        { alan: "vade",        etiket: "VADE",        renk: "#16a34a" },
        { alan: "para_birimi", etiket: "PARA BİRİMİ", renk: "#a78bfa" },
    ],
    hacim_profili: [
        { alan: "sinyal",                etiket: "SİNYAL",     renk: "#3b82f6" },
        { alan: "va_durum",              etiket: "VA DURUMU",  renk: "#eab308" },
        { alan: "hacim_yogunluk_skoru",  etiket: "SKOR",       renk: "#16a34a" },
        { alan: "para_birimi",           etiket: "PARA BİRİMİ",renk: "#a78bfa" },
    ],
    hacim_akisi: [
        { alan: "sinyal",          etiket: "SİNYAL",      renk: "#3b82f6" },
        { alan: "ha_skoru",        etiket: "HA SKORU",    renk: "#eab308" },
        { alan: "spike_katsayisi", etiket: "SPIKE",       renk: "#16a34a" },
        { alan: "momentum",       etiket: "MOMENTUM",    renk: "#f59e0b" },
        { alan: "sureklilik",     etiket: "SÜREKLİLİK",  renk: "#0d9488" },
        { alan: "para_birimi",   etiket: "PARA BİRİMİ", renk: "#a78bfa" },
    ],
    divergence: [
        { alan: "tip",               etiket: "TİP",              renk: "#3b82f6" },
        { alan: "konfluence_skoru",  etiket: "KONFLUENCE SKORU", renk: "#eab308" },
        { alan: "guc",               etiket: "GÜÇ",              renk: "#16a34a" },
        { alan: "osilatorler",       etiket: "OSİLATÖRLER",      renk: "#f59e0b" },
        { alan: "onay_durumu",       etiket: "ONAY DURUMU",      renk: "#0d9488" },
        { alan: "pivot_tipi",        etiket: "PİVOT TİPİ",       renk: "#ec4899" },
        { alan: "para_birimi",       etiket: "PARA BİRİMİ",      renk: "#a78bfa" },
    ],
    birlesik_skor: [
        { alan: "konfidans",             etiket: "KONFİDANS",     renk: "#3b82f6" },
        { alan: "kademe",                etiket: "KADEME",        renk: "#eab308" },
        { alan: "yon",                   etiket: "YÖN",           renk: "#16a34a" },
        { alan: "aktif_modul_sayisi",    etiket: "CONFLUENCE",    renk: "#f59e0b" },
        { alan: "sektorel_momentum",     etiket: "SEKTÖR RS",     renk: "#0d9488" },
        { alan: "haber_duygu_skoru",     etiket: "HABER SKORU",   renk: "#ec4899" },
        { alan: "risk_skoru",            etiket: "RİSK SKORU",    renk: "#dc2626" },
        { alan: "para_birimi",           etiket: "PARA BİRİMİ",   renk: "#a78bfa" },
    ],
};

const DILIMLER = [
    { key: "d0",   label: "Aynı Gün" },
    { key: "d1",   label: "+1 Gün"   },
    { key: "d7",   label: "+1 Hafta" },
    { key: "d30",  label: "+1 Ay"    },
    { key: "d90",  label: "+3 Ay"    },
    { key: "d180", label: "+6 Ay"    },
    { key: "d365", label: "+1 Yıl"   },
];


// Para birimine göre anlık fiyatı seç
const getAnlik = (row, anlıkFiyatlar) => {
    const pb = row.para_birimi || "";
    if (pb.includes("TL") || pb === "TL") {
        return anlıkFiyatlar[row.symbol + "_tl"] ?? anlıkFiyatlar[row.symbol] ?? null;
    }
    return anlıkFiyatlar[row.symbol + "_usd"] ?? anlıkFiyatlar[row.symbol] ?? null;
};

// Satırın "ayı" yönlü olup olmadığını belirler
const YON_MAP = {
    likidite_tara:   (r) => r.sweep_tipi  && r.sweep_tipi.includes("Ayı"),
    divergence:      (r) => r.tip && r.tip.includes("Bearish"),
    birlesik_skor:   (r) => r.yon === "SATIŞ",
    fvg_tara:        (r) => r.fvg_tip    && r.fvg_tip.includes("Ayı"),
    capa_tara:       (r) => r.capa_tipi  && r.capa_tipi.includes("Ayı"),
    msb_tara:        (r) => r.msb_tipi   && r.msb_tipi.includes("Ayı"),
    ote_tara:        (r) => r.ote_tipi   && r.ote_tipi.includes("Ayı"),
    obbb_tara:       (r) => r.ob_tipi    && r.ob_tipi.includes("Ayı"),
    inducement_tara: (r) => r.idm_tipi   && r.idm_tipi.includes("Ayı"),
    pd_tara:         (r) => r.yon_onerisi && r.yon_onerisi.includes("Sat"),
    smt_tara:        (r) => r.smt_tipi   && r.smt_tipi.includes("Ayı"),
    killzone_tara:   (r) => r.yapi_tipi  && r.yapi_tipi.includes("Ayı"),
    topdown_tara:    (r) => r.trend === "SHORT",
    islem_planlama:  (r) => r.yon && /düş|short|sat/i.test(r.yon),
    puanlama_tara:   (r) => r.yon && /düş|short|sat/i.test(r.yon),
};

// Satır için doğru pct'yi döndürür (ayı ise low_pct, boğa ise pct)
const getPct = (row, dilimKey, modul) => {
    const ayi = YON_MAP[modul]?.(row) ?? false;
    return ayi ? (row[`${dilimKey}_low_pct`] ?? null) : (row[`${dilimKey}_pct`] ?? null);
};
const getHigh = (row, dilimKey, modul) => {
    const ayi = YON_MAP[modul]?.(row) ?? false;
    return ayi ? (row[`${dilimKey}_low`] ?? null) : (row[`${dilimKey}_high`] ?? null);
};


// MFE/MAE hesaplaması yapılan modüller ve dilimleri
const MFE_MODULLER  = new Set(["puanlama_tara", "karar_motoru"]);
const MFE_DILIMLER  = [
    { key: "d1",  label: "+1 Gün"   },
    { key: "d7",  label: "+1 Hafta" },
    { key: "d30", label: "+1 Ay"    },
    { key: "d90", label: "+3 Ay"    },
];

const fmt = (v, basamak = 4) => {
    if (v == null) return "—";
    const n = parseFloat(v);
    if (isNaN(n)) return "—";
    return n.toFixed(basamak).replace(/\.?0+$/, "") || "0";
};

const pctRenk = (pct) => {
    if (pct == null) return "#94a3b8";
    return pct > 0 ? "#16a34a" : pct < 0 ? "#dc2626" : "#94a3b8";
};




/* ── Saf SVG Grafik (recharts bağımlılığı yok) ───────────── */
function SvgGrafik({ veri, bazFiyat, basamak }) {
    const [tooltip, setTooltip] = useState(null);
    if (!veri || veri.length === 0) return null;

    const W = 800, H = 180, PL = 60, PR = 20, PT = 10, PB = 30;
    const cW = W - PL - PR, cH = H - PT - PB;

    const highs = veri.map(d => d.high);
    const minH  = Math.min(...highs, bazFiyat || Infinity) * 0.995;
    const maxH  = Math.max(...highs, bazFiyat || 0) * 1.005;
    const rng   = maxH - minH || 1;

    const xPos = (i) => PL + (i / (veri.length - 1 || 1)) * cW;
    const yPos = (v) => PT + cH - ((v - minH) / rng) * cH;

    const pts = veri.map((d, i) => `${xPos(i)},${yPos(d.high)}`).join(" ");

    // Y ekseni etiketleri
    const yTicks = 4;
    const yLabels = Array.from({ length: yTicks + 1 }, (_, i) => {
        const v = minH + (rng * i) / yTicks;
        return { v, y: yPos(v) };
    });

    // X ekseni: ~6 etiket
    const xStep = Math.max(1, Math.floor(veri.length / 6));
    const xLabels = veri
        .map((d, i) => ({ i, label: d.tarih?.slice(5) }))
        .filter((_, i) => i % xStep === 0 || i === veri.length - 1);

    return (
        <div style={{ position: "relative", width: "100%", overflowX: "auto" }}>
            <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", minWidth: 400, height: H }}
                onMouseLeave={() => setTooltip(null)}>
                {/* Grid yatay */}
                {yLabels.map((t, i) => (
                    <line key={i} x1={PL} y1={t.y} x2={W - PR} y2={t.y}
                        stroke="#334155" strokeWidth={0.5} />
                ))}
                {/* Y etiketleri */}
                {yLabels.map((t, i) => (
                    <text key={i} x={PL - 4} y={t.y + 3}
                        textAnchor="end" fontSize={9} fill="#94a3b8">
                        {Number(t.v).toFixed(basamak > 4 ? 4 : 2)}
                    </text>
                ))}
                {/* X etiketleri */}
                {xLabels.map(({ i, label }) => (
                    <text key={i} x={xPos(i)} y={H - 4}
                        textAnchor="middle" fontSize={9} fill="#94a3b8">
                        {label}
                    </text>
                ))}
                {/* Baz fiyat çizgisi */}
                {bazFiyat && bazFiyat >= minH && bazFiyat <= maxH && (
                    <>
                        <line x1={PL} y1={yPos(bazFiyat)} x2={W - PR} y2={yPos(bazFiyat)}
                            stroke="#f59e0b" strokeWidth={1} strokeDasharray="5 3" />
                        <text x={W - PR + 2} y={yPos(bazFiyat) + 3}
                            fontSize={8} fill="#f59e0b">Baz</text>
                    </>
                )}
                {/* Çizgi */}
                <polyline points={pts} fill="none" stroke="#2563eb" strokeWidth={1.5} />
                {/* Tooltip hit alanı */}
                {veri.map((d, i) => (
                    <rect key={i}
                        x={xPos(i) - (cW / veri.length / 2)}
                        y={PT} width={cW / veri.length} height={cH}
                        fill="transparent"
                        onMouseEnter={(e) => setTooltip({
                            x: xPos(i), y: yPos(d.high),
                            tarih: d.tarih, high: d.high,
                            pct: bazFiyat && bazFiyat > 0
                                ? ((d.high - bazFiyat) / bazFiyat * 100).toFixed(2) : null,
                        })} />
                ))}
                {/* Tooltip nokta + kutu */}
                {tooltip && (
                    <>
                        <circle cx={tooltip.x} cy={tooltip.y} r={3}
                            fill="#2563eb" stroke="white" strokeWidth={1} />
                        <g transform={`translate(${Math.min(tooltip.x + 6, W - 120)},${Math.max(tooltip.y - 42, PT)})`}>
                            <rect width={110} height={42} rx={4}
                                fill="#1e293b" stroke="#334155" strokeWidth={0.5}
                                style={{ filter: "drop-shadow(0 1px 3px rgba(0,0,0,0.1))" }} />
                            <text x={6} y={13} fontSize={9} fill="#94a3b8">{tooltip.tarih}</text>
                            <text x={6} y={25} fontSize={10} fontWeight="600" fill="#e2e8f0">
                                {Number(tooltip.high).toFixed(basamak > 4 ? 4 : basamak)}
                            </text>
                            {tooltip.pct !== null && (
                                <text x={6} y={37} fontSize={9}
                                    fill={parseFloat(tooltip.pct) >= 0 ? "#16a34a" : "#dc2626"}>
                                    {parseFloat(tooltip.pct) >= 0 ? "+" : ""}{tooltip.pct}%
                                </text>
                            )}
                        </g>
                    </>
                )}
            </svg>
        </div>
    );
}


// Her modülün backend endpoint prefix'i
const MODUL_ENDPOINT = {
    dip_tara:      "dip-tarama-analiz",
    likidite_tara: "likidite-tarama-analiz",
    fvg_tara:      "fvg-tarama-analiz",
    capa_tara:     "capa-tarama-analiz",
    msb_tara:      "msb-tarama-analiz",
    ote_tara:      "ote-tarama-analiz",
    obbb_tara:     "obbb-tarama-analiz",
    inducement_tara: "inducement-tarama-analiz",
    pd_tara:       "pd-tarama-analiz",
    smt_tara:      "smt-tarama-analiz",
    killzone_tara: "killzone-tarama-analiz",
    coklu_tara:    "coklu-tarama-analiz",
    topdown_tara:  "topdown-tarama-analiz",
    puanlama_tara:   "puanlama-tarama-analiz",
    karar_motoru:    "karar-motoru-analiz",
    hacim_profili:   "hacim-profili-tarama-analiz",
    hacim_akisi:     "hacim-akisi-tarama-analiz",
    divergence:      "divergence-tarama-analiz",
    birlesik_skor:   "birlesik-skor-tarama-analiz",
    islem_planlama:  "islem-planlama-analiz",
};

// Her modülün sabit tablo kolonları: { label, kol }
const MODUL_KOLONLAR = {
    dip_tara: [
        { label: "Hisse",       kol: "symbol"      },
        { label: "Durum",       kol: "durum"       },
        { label: "Tolerans",    kol: "tolerans"    },
        { label: "Periyot",     kol: "periyot"     },
        { label: "Para Birimi", kol: "para_birimi" },
        { label: "Baz Fiyat",   kol: "baz_fiyat"  },
        { label: "Dip Fiyat",   kol: "dip_fiyat"  },
        { label: "Fark %",      kol: "fark_pct"   },
    ],
    islem_planlama: [
        { label: "Hisse",            kol: "symbol"           },
        { label: "Yön",              kol: "yon"              },
        { label: "Durum",            kol: "durum"            },
        { label: "İşlem Tipi",       kol: "islem_tipi"       },
        { label: "Para Birimi",      kol: "para_birimi"      },
        { label: "Baz Fiyat",        kol: "baz_fiyat"        },
    ],
    birlesik_skor: [
        { label: "Hisse",         kol: "symbol"                    },
        { label: "Konfidans",     kol: "konfidans"                 },
        { label: "Kademe",        kol: "kademe"                    },
        { label: "Yön",           kol: "yon"                       },
        { label: "Confluence",    kol: "aktif_modul_sayisi"        },
        { label: "Sektör RS",     kol: "sektorel_momentum"         },
        { label: "Haber Skoru",   kol: "haber_duygu_skoru"         },
        { label: "Risk Skoru",    kol: "risk_skoru"                },
        { label: "Para Birimi",   kol: "para_birimi"               },
        { label: "Baz Fiyat",     kol: "baz_fiyat"                 },
    ],
    divergence: [
        { label: "Hisse",            kol: "symbol"             },
        { label: "Tip",              kol: "tip"                },
        { label: "Konfluence Skoru", kol: "konfluence_skoru"   },
        { label: "Güç",              kol: "guc"                },
        { label: "Osilatörler",      kol: "osilatorler"        },
        { label: "Onay Durumu",      kol: "onay_durumu"        },
        { label: "Pivot Tipi",       kol: "pivot_tipi"         },
        { label: "Para Birimi",      kol: "para_birimi"        },
        { label: "Baz Fiyat",        kol: "baz_fiyat"          },
    ],
    hacim_akisi: [
        { label: "Hisse",      kol: "symbol"          },
        { label: "Sinyal",     kol: "sinyal"          },
        { label: "HA Skoru",   kol: "ha_skoru"        },
        { label: "Spike",      kol: "spike_katsayisi" },
        { label: "Momentum",   kol: "momentum"        },
        { label: "Süreklilik", kol: "sureklilik"      },
        { label: "Para Birimi",kol: "para_birimi"     },
        { label: "Baz Fiyat",  kol: "baz_fiyat"       },
    ],
    hacim_profili: [
        { label: "Hisse",           kol: "symbol"                },
        { label: "Sinyal",          kol: "sinyal"                },
        { label: "VA Durumu",       kol: "va_durum"              },
        { label: "Skor",            kol: "hacim_yogunluk_skoru"  },
        { label: "Para Birimi",     kol: "para_birimi"           },
        { label: "Baz Fiyat",       kol: "baz_fiyat"             },
    ],
    karar_motoru: [
        { label: "Hisse",       kol: "symbol"      },
        { label: "Giriş Skoru", kol: "giris_skoru" },
        { label: "Karar",       kol: "karar"       },
        { label: "Vade",        kol: "vade"        },
        { label: "Para Birimi", kol: "para_birimi" },
        { label: "Baz Fiyat",   kol: "baz_fiyat"   },
    ],
    puanlama_tara: [
        { label: "Hisse",       kol: "symbol"       },
        { label: "Güven Skoru", kol: "guven_skoru"  },
        { label: "Yön",         kol: "yon"          },
        { label: "Vade",        kol: "vade"         },
        { label: "Para Birimi", kol: "para_birimi"  },
        { label: "Baz Fiyat",   kol: "baz_fiyat"    },
    ],
    topdown_tara: [
        { label: "Hisse",          kol: "symbol"      },
        { label: "Trend",          kol: "trend"       },
        { label: "EMA 200",        kol: "ema200"      },
        { label: "Sweep Tipi",     kol: "sweep_tipi"  },
        { label: "Para Birimi",    kol: "para_birimi" },
        { label: "Baz Fiyat",      kol: "baz_fiyat"   },
    ],
    coklu_tara: [
        { label: "Hisse",          kol: "symbol"      },
        { label: "Modüller",       kol: "moduller"    },
        { label: "Para Birimi",    kol: "para_birimi" },
        { label: "Baz Fiyat",      kol: "baz_fiyat"   },
    ],
    killzone_tara: [
        { label: "Hisse",          kol: "symbol"        },
        { label: "Killzone",       kol: "killzone"      },
        { label: "Yapı Tipi",      kol: "yapi_tipi"     },
        { label: "Hacim Onayı",    kol: "hacim_onayi"   },
        { label: "Sınıf",          kol: "sinif"         },
        { label: "Para Birimi",    kol: "para_birimi"   },
        { label: "Baz Fiyat",      kol: "baz_fiyat"     },
    ],
    smt_tara: [
        { label: "Hisse",          kol: "symbol"          },
        { label: "SMT Tipi",       kol: "smt_tipi"        },
        { label: "Güç",            kol: "guc"             },
        { label: "Tarama Periyot", kol: "tarama_periyot"  },
        { label: "Para Birimi",    kol: "para_birimi"     },
        { label: "Baz Fiyat",      kol: "baz_fiyat"       },
    ],
    pd_tara: [
        { label: "Hisse",          kol: "symbol"         },
        { label: "Bölge",          kol: "bolge"          },
        { label: "Yön Önerisi",    kol: "yon_onerisi"    },
        { label: "Tarama Periyot", kol: "tarama_periyot" },
        { label: "Para Birimi",    kol: "para_birimi"    },
        { label: "Baz Fiyat",      kol: "baz_fiyat"      },
    ],
    inducement_tara: [
        { label: "Hisse",          kol: "symbol"          },
        { label: "IDM Tipi",       kol: "idm_tipi"        },
        { label: "Sweep Durumu",   kol: "sweep_durumu"    },
        { label: "Durum",          kol: "durum"            },
        { label: "Tarama Periyot", kol: "tarama_periyot"  },
        { label: "Para Birimi",    kol: "para_birimi"     },
        { label: "Baz Fiyat",      kol: "baz_fiyat"       },
    ],
    obbb_tara: [
        { label: "Hisse",          kol: "symbol"         },
        { label: "OB/BB Tipi",     kol: "ob_tipi"        },
        { label: "Displacement",   kol: "displacement"   },
        { label: "FVG Onayı",      kol: "fvg_onayi"      },
        { label: "Güç",            kol: "guc"            },
        { label: "Tarama Periyot", kol: "tarama_periyot" },
        { label: "Para Birimi",    kol: "para_birimi"    },
        { label: "Baz Fiyat",      kol: "baz_fiyat"      },
    ],
    ote_tara: [
        { label: "Hisse",          kol: "symbol"        },
        { label: "OTE Tipi",       kol: "ote_tipi"      },
        { label: "Durum",          kol: "durum"          },
        { label: "Tarama Periyot", kol: "tarama_periyot" },
        { label: "Para Birimi",    kol: "para_birimi"   },
        { label: "Baz Fiyat",      kol: "baz_fiyat"     },
    ],
    msb_tara: [
        { label: "Hisse",           kol: "symbol"         },
        { label: "MSB Tipi",        kol: "msb_tipi"       },
        { label: "Kırılan Seviye",  kol: "kirilan_seviye" },
        { label: "Güçlü Kırılım",   kol: "guclu_kirilim"  },
        { label: "Tarama Periyot",  kol: "tarama_periyot" },
        { label: "Para Birimi",     kol: "para_birimi"    },
        { label: "Baz Fiyat",       kol: "baz_fiyat"      },
    ],
    capa_tara: [
        { label: "Hisse",        kol: "symbol"       },
        { label: "FVG Tipi",     kol: "fvg_tip"      },
        { label: "Temas Sayısı", kol: "temas_sayisi" },
        { label: "Çapa Durum",   kol: "capa_durum"   },
        { label: "Para Birimi",  kol: "para_birimi"  },
        { label: "Baz Fiyat",    kol: "baz_fiyat"    },
    ],
    fvg_tara: [
        { label: "Hisse",           kol: "symbol"         },
        { label: "FVG Tipi",        kol: "fvg_tip"        },
        { label: "FVG Durumu",      kol: "fvg_durumu"     },
        { label: "BPR Durumu",      kol: "bpr_durumu"     },
        { label: "Tarama Periyot",  kol: "tarama_periyot" },
        { label: "Para Birimi",     kol: "para_birimi"    },
        { label: "Baz Fiyat",       kol: "baz_fiyat"      },
    ],
    likidite_tara: [
        { label: "Hisse",            kol: "symbol"          },
        { label: "Sweep Tipi",       kol: "sweep_tipi"      },
        { label: "Kalite",           kol: "kalite"          },
        { label: "Para Birimi",      kol: "para_birimi"     },
        { label: "Tarama Periyot",   kol: "tarama_periyot"  },
        { label: "Baz Fiyat",        kol: "baz_fiyat"      },
    ],
};

// Boş mesaj metni
const MODUL_BOS_MESAJ = {
    dip_tara:      "Dip Tarama sayfasında hisse seçip",
    likidite_tara: "Likidite Tarama sayfasında hisse seçip",
    fvg_tara:      "FVG Tarama sayfasında hisse seçip",
    capa_tara:     "Çapa Tarama sayfasında hisse seçip",
    msb_tara:      "MSB Tarama sayfasında hisse seçip",
    ote_tara:      "OTE Tarama sayfasında hisse seçip",
    obbb_tara:     "OB&BB Tarama sayfasında hisse seçip",
    inducement_tara: "IDM Tarama sayfasında hisse seçip",
    pd_tara:       "P/D Tarama sayfasında hisse seçip",
    smt_tara:      "SMT Tarama sayfasında hisse seçip",
    killzone_tara: "KillZone Tarama sayfasında hisse seçip",
    coklu_tara:    "Çoklu Tarama sayfasında kesişim sonuçlarını seçip",
    topdown_tara:  "Topdown Cascade sayfasında hisse seçip",
    puanlama_tara:   "Puanlama sayfasında hisse seçip",
    karar_motoru:    "Karar Motoru sayfasında hisse seçip",
    hacim_profili:   "Hacim Profili Tarama sayfasında hisse seçip",
    hacim_akisi:     "Hacim Akışı Tarama sayfasında hisse seçip",
    divergence:      "Divergence Tarama sayfasında hisse seçip",
    birlesik_skor:   "Birleşik Skor sayfasında sembol seçip",
    islem_planlama:  "İşlem Planlama sayfasında hisse seçip",
};

// --- İndir Alt Menüsü (hover ile açılır) ---
function IndirAltMenu({ onExcel, onCsv, onPdf, onSvg }) {
    const [acik, setAcik] = useState(false);
    return (
        <div style={{ position: "relative" }} onMouseEnter={() => setAcik(true)} onMouseLeave={() => setAcik(false)}>
            <button style={{ display: "flex", width: "100%", textAlign: "left", justifyContent: "space-between",
                padding: "10px 14px", border: "none", background: "none", cursor: "pointer",
                color: "#e2e8f0", fontSize: 13, borderBottom: "1px solid #334155" }}>
                📥 İndir <span style={{ color: "#94a3b8" }}>▶</span>
            </button>
            {acik && (
                <div style={{ position: "absolute", left: "100%", top: 0, background: "#1e293b",
                    border: "1px solid #334155", borderRadius: 8,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.4)", minWidth: 160, overflow: "hidden", zIndex: 101 }}>
                    {[
                        { l: "Excel (.xlsx)", fn: onExcel },
                        { l: "CSV (.csv)",    fn: onCsv   },
                        { l: "PDF (.pdf)",    fn: onPdf   },
                        { l: "SVG (.svg)",    fn: onSvg   },
                    ].map(b => (
                        <button key={b.l} onClick={b.fn}
                            style={{ display: "block", width: "100%", textAlign: "left", padding: "9px 14px",
                                border: "none", background: "none", cursor: "pointer", color: "#e2e8f0", fontSize: 13,
                                borderBottom: "1px solid #334155" }}>{b.l}</button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default function DogrulukAnalizi() {
    const [seciliModul,        setSeciliModul]        = useState("dip_tara");
    const [piyasa,             setPiyasa]             = useState("BIST");
    const [seciliTarih,        setSeciliTarih]        = useState(null);
    const [tarihler,           setTarihler]           = useState([]);
    const [liste,              setListe]              = useState([]);
    const [mfeTooltip,         setMfeTooltip]         = useState(null); // { alan, x, y }
    const [listelenenModul,    setListelenenModul]    = useState("dip_tara");
    const [kolonFiltreler,     setKolonFiltreler]     = useState({});  // { kol: "arama metni" }
    const [listelenenPiyasa,   setListelenenPiyasa]   = useState("BIST");
    const [yukleniyor,         setYukleniyor]         = useState(false);
    const [grafikPopupRow,      setGrafikPopupRow]      = useState(null);
    const [grafikVeri,         setGrafikVeri]         = useState([]);
    const [anlıkFiyatlar,      setAnlıkFiyatlar]      = useState({});
    const [usdTryKur,          setUsdTryKur]          = useState(null);
    const [grafikYukleniyor,   setGrafikYukleniyor]   = useState(false);
    const [siralamaKol,        setSiralamaKol]        = useState(null);
    const [siralamaYon,        setSiralamaYon]        = useState("asc");
    // Checkbox state
    const [secilenler,         setSecilenler]         = useState(new Set());
    // İşlemler menüsü
    const [islemMenuAcik,      setIslemMenuAcik]      = useState(false);
    // Alarm popup
    const [alarmPopup,         setAlarmPopup]         = useState(false);
    const [alarmHisseler,      setAlarmHisseler]      = useState([]);
    const [hedefFiyatlar,      setHedefFiyatlar]      = useState({});
    const [alarmMail,          setAlarmMail]          = useState(false);
    const [alarmBildirim,      setAlarmBildirim]      = useState(true);
    const [alarmKaydediliyor,  setAlarmKaydediliyor]  = useState(false);
    // Silme
    const [silOnay,            setSilOnay]            = useState(false);
    const [siliyor,            setSiliyor]            = useState(false);

    // Dip Tarama filtre kartı: Durum / Tolerans / Para Birimi (Piyasa zaten listelenenPiyasa'dan sabit)
    // Modüle göre değişen sonuç filtre kartı: { alanAdi: Set(seçili değerler) }
    const [modulFiltreleri, setModulFiltreleri] = useState({});
    const toggleModulFiltre = (alan, deger) => setModulFiltreleri(prev => {
        const mevcut = new Set(prev[alan] || []);
        mevcut.has(deger) ? mevcut.delete(deger) : mevcut.add(deger);
        return { ...prev, [alan]: mevcut };
    });
	

    const getToken = async () => {
        const { data: { session } } = await supabase.auth.getSession();
        return session?.access_token;
    };

    const yukleTarihler = useCallback(async (p, modul) => {
        const endpoint = MODUL_ENDPOINT[modul] || "dip-tarama-analiz";
        try {
            const token = await getToken();
            const res = await axios.get(`${API_URL}/scan/${endpoint}/tarihler`, {
                params: { mod: p },
                headers: { Authorization: `Bearer ${token}` },
            });
            const l = res.data || [];
            setTarihler(l);
            setSeciliTarih(l[0] || null);
        } catch { toast.error("Tarihler yüklenemedi"); }
    }, []);

    const yukleListeData = useCallback(async (p, tarih, modul) => {
        if (!tarih) { setListe([]); return; }
        const endpoint = MODUL_ENDPOINT[modul] || "dip-tarama-analiz";
        setYukleniyor(true);
        setSecilenler(new Set());
        try {
            const token = await getToken();
            const res = await axios.get(`${API_URL}/scan/${endpoint}/listele`, {
                params: { mod: p, kayit_tarihi: tarih },
                headers: { Authorization: `Bearer ${token}` },
            });
            const veri = res.data || [];
            setListe(veri);
            // Anlık fiyatları çek
            if (veri.length > 0) {
                const semboller = [...new Set(veri.map(r => r.symbol))];
                try {
                    const [res2, res3] = await Promise.all([
                        axios.post(`${API_URL}/scan/dogruluk-anlik-fiyatlar`,
                            { semboller, mod: p },
                            { headers: { Authorization: `Bearer ${token}` } }
                        ),
                        axios.get(`${API_URL}/scan/dogruluk-usd-try-kur`,
                            { headers: { Authorization: `Bearer ${token}` } }
                        ),
                    ]);
                    setAnlıkFiyatlar(res2.data || {});
                    setUsdTryKur(res3.data?.kur || null);
                } catch { setAnlıkFiyatlar({}); setUsdTryKur(null); }
            }
        } catch { toast.error("Liste yüklenemedi"); }
        finally { setYukleniyor(false); }
    }, []);

    const yukleGrafik = async (row) => {
        if (grafikPopupRow?.symbol === row.symbol) { setGrafikPopupRow(null); setGrafikVeri([]); return; }
        setGrafikPopupRow(row);
        setGrafikVeri([]);
        setGrafikYukleniyor(true);
        const endpoint = MODUL_ENDPOINT[listelenenModul] || "dip-tarama-analiz";
        try {
            const token = await getToken();
            const res = await axios.get(`${API_URL}/scan/${endpoint}/grafik`, {
                params: { symbol: row.symbol, mod: piyasa, kayit_tarihi: row.kayit_tarihi, para_birimi: row.para_birimi },
                headers: { Authorization: `Bearer ${token}` },
            });
            setGrafikVeri(res.data || []);
        } catch { toast.error("Grafik verisi yüklenemedi"); }
        finally { setGrafikYukleniyor(false); }
    };


    useEffect(() => {
        // Modül veya piyasa değişince sadece tarih listesini yenile
        yukleTarihler(piyasa, seciliModul);
    }, [piyasa, seciliModul]);

    const listeleHandler = () => {
        setGrafikPopupRow(null); setGrafikVeri([]);
        setSecilenler(new Set()); setAnlıkFiyatlar({});
        setListelenenModul(seciliModul);
        setListelenenPiyasa(piyasa);
        setKolonFiltreler({});
        setModulFiltreleri({});
        yukleListeData(piyasa, seciliTarih, seciliModul);
    };

    /* ── Sıralama ─────────────────────────────────────────── */
    const siralamaToggle = (kol) => {
        if (siralamaKol === kol) setSiralamaYon(y => y === "asc" ? "desc" : "asc");
        else { setSiralamaKol(kol); setSiralamaYon("asc"); }
    };

    // Sabit kolonlar (modüle göre)
    const aktifKolonlar = MODUL_KOLONLAR[listelenenModul] || MODUL_KOLONLAR.dip_tara;
    const sabitKolonKeys = aktifKolonlar.map(k => k.kol);

    // Likidite taramada ek kolon gösterilmez — sadece tanımlı kolonlar
    const dipSutunlar = ["dip_tara","likidite_tara","fvg_tara","capa_tara","msb_tara","ote_tara","obbb_tara","inducement_tara","pd_tara","smt_tara","killzone_tara","puanlama_tara","islem_planlama","coklu_tara","topdown_tara","karar_motoru","hacim_profili","hacim_akisi","divergence","birlesik_skor"].includes(listelenenModul) ? [] : (liste.length > 0
        ? Object.keys(liste[0]).filter(k =>
            ![...sabitKolonKeys,
              "id","user_id","mod","kayit_tarihi","olusturuldu_at","guncellendi_at",
              "dip_tarihi","dip_fiyat","fark_pct","durum","tolerans",
              "referans_seviye","sweep_tipi","kalite","tarama_periyot",
              ...DILIMLER.flatMap(d => [`${d.key}_high`,`${d.key}_pct`,`${d.key}_low`,`${d.key}_low_pct`])
            ].includes(k) && !/^\d{4}/.test(k))
        : []);

    // Kolon filtresi uygula
    const filtrelenmisListe = liste.filter(row => {
        const kolonUyumlu = Object.entries(kolonFiltreler).every(([kol, deger]) => {
            if (!deger) return true;
            const v = row[kol];
            if (v == null) return false;
            return String(v).toLowerCase().includes(deger.toLowerCase());
        });
        if (!kolonUyumlu) return false;
        const filtreAlanlari = MODUL_FILTRE_ALANLARI[listelenenModul];
        if (filtreAlanlari) {
            for (const f of filtreAlanlari) {
                if (f.sabit) continue; // sabit rozetler (ör. Piyasa) filtrelemez, sadece bilgi gösterir
                const secili = modulFiltreleri[f.alan];
                if (secili && secili.size > 0 && !secili.has(row[f.alan])) return false;
            }
        }
        return true;
    });

    const siralanmisListe = [...filtrelenmisListe].sort((a, b) => {
        if (!siralamaKol) return 0;
        const av = a[siralamaKol], bv = b[siralamaKol];
        if (av == null && bv == null) return 0;
        if (av == null) return 1; if (bv == null) return -1;
        const an = parseFloat(av), bn = parseFloat(bv);
        const cmp = (!isNaN(an) && !isNaN(bn)) ? an - bn : String(av).localeCompare(String(bv), "tr");
        return siralamaYon === "asc" ? cmp : -cmp;
    });

    /* ── İndirme ─────────────────────────────────────────────── */
    const indirVerisi = () => {
        const aktifKolonlar = MODUL_KOLONLAR[listelenenModul] || MODUL_KOLONLAR.dip_tara;
        return siralanmisListe.map(row => {
            const obj = {};
            aktifKolonlar.forEach(({ label, kol }) => { obj[label] = row[kol] ?? ""; });
            DILIMLER.forEach(d => {
                const high = row[`${d.key}_high`];
                const pct  = row[`${d.key}_pct`];
                obj[d.label] = high != null ? high : "";
                obj[`${d.label} %`] = pct != null ? pct : "";
            });
            obj["Kayıt Tarihi"] = row.kayit_tarihi || "";
            return obj;
        });
    };

    const excelIndir = () => {
        if (!liste.length) return;
        const modLabel = MODULLER.find(m => m.key === listelenenModul)?.label || listelenenModul;
        const veri = indirVerisi();
        const ws = XLSX.utils.json_to_sheet(veri);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Doğruluk Analizi");
        XLSX.writeFile(wb, `${modLabel}_${seciliTarih}.xlsx`);
        setIslemMenuAcik(false);
    };

    const csvIndir = () => {
        if (!liste.length) return;
        const modLabel = MODULLER.find(m => m.key === listelenenModul)?.label || listelenenModul;
        const veri = indirVerisi();
        const basliklar = Object.keys(veri[0]);
        const satirlar = veri.map(row =>
            basliklar.map(h => {
                const v = row[h];
                if (v === null || v === undefined || v === "") return "";
                const str = String(v);
                return str.includes(",") || str.includes('"') ? `"${str.replace(/"/g,'""')}"` : str;
            }).join(",")
        );
        const csv = [basliklar.join(","), ...satirlar].join("\n");
        const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = `${modLabel}_${seciliTarih}.csv`;
        a.click(); URL.revokeObjectURL(url);
        setIslemMenuAcik(false);
    };

    const svgIndir = () => {
        if (!liste.length) return;
        const modLabel = MODULLER.find(m => m.key === listelenenModul)?.label || listelenenModul;
        const aktifKolonlar = MODUL_KOLONLAR[listelenenModul] || MODUL_KOLONLAR.dip_tara;
        const basliklar = [...aktifKolonlar.map(k => k.label), ...DILIMLER.map(d => d.label), "Kayıt Tarihi"];
        const satirlar = siralanmisListe.map(row => {
            const cells = aktifKolonlar.map(({ kol }) => row[kol] != null ? String(row[kol]) : "—");
            DILIMLER.forEach(d => {
                const high = row[`${d.key}_high`];
                const pct  = row[`${d.key}_pct`];
                cells.push(high != null ? `${Number(high).toFixed(4)}${pct!=null?" ("+(pct>0?"+":"")+pct+"%)":""}` : "—");
            });
            cells.push(row.kayit_tarihi || "");
            return cells;
        });
        const colW = Math.max(60, Math.floor(740 / basliklar.length));
        const rowH = 18, headerH = 24;
        const tableW = colW * basliklar.length;
        const pageW = Math.max(tableW + 40, 800);
        const pageH = 80 + headerH + satirlar.length * rowH;
        const esc = s => String(s).slice(0,18).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
        const svgRows = satirlar.map((cells, i) =>
            `<g transform="translate(20,${60+headerH+i*rowH})">
                <rect width="${tableW}" height="${rowH}" fill="${i%2===0?"#fff":"#182234"}" stroke="#334155" stroke-width="0.5"/>
                ${cells.map((c,j)=>`<text x="${j*colW+4}" y="13" font-size="9" fill="#e2e8f0" font-family="Arial">${esc(c)}</text>`).join("")}
            </g>`).join("");
        const svgHead = basliklar.map((h,j)=>
            `<text x="${20+j*colW+4}" y="48" font-size="9" font-weight="bold" fill="white" font-family="Arial">${esc(h)}</text>`).join("");
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${pageW}" height="${pageH}">
            <rect width="${pageW}" height="${pageH}" fill="white"/>
            <text x="20" y="22" font-size="14" font-weight="bold" fill="#1e3a5f" font-family="Arial">Doğruluk Analizi — ${modLabel} — ${seciliTarih}</text>
            <text x="20" y="38" font-size="10" fill="#94a3b8" font-family="Arial">${liste.length} kayıt | ${new Date().toLocaleDateString("tr-TR")}</text>
            <rect x="20" y="52" width="${tableW}" height="${headerH}" fill="#1e3a5f"/>
            ${svgHead}${svgRows}
        </svg>`;
        const blob = new Blob([svg], { type: "image/svg+xml" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a"); a.href = url;
        a.download = `${modLabel}_${seciliTarih}.svg`;
        a.click(); URL.revokeObjectURL(url);
        setIslemMenuAcik(false);
    };

    const pdfIndir = async () => {
        if (!liste.length) return;
        const modLabel = MODULLER.find(m => m.key === listelenenModul)?.label || listelenenModul;
        try {
            const { default: jsPDF } = await import("jspdf");
            const { default: autoTable } = await import("jspdf-autotable");
            const veri = indirVerisi();
            const basliklar = Object.keys(veri[0] || {});
            const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
            doc.setFontSize(14); doc.text(`Doğruluk Analizi — ${modLabel}`, 20, 30);
            doc.setFontSize(9); doc.setTextColor(100);
            doc.text(`${liste.length} kayıt · ${seciliTarih} · ${new Date().toLocaleDateString("tr-TR")}`, 20, 48);
            autoTable(doc, {
                head: [basliklar],
                body: veri.map(r => basliklar.map(h => String(r[h] ?? ""))),
                startY: 58,
                styles: { fontSize: 7, cellPadding: 3 },
                headStyles: { fillColor: [29, 78, 216], textColor: 255, fontStyle: "bold" },
                alternateRowStyles: { fillColor: [245, 247, 250] },
            });
            doc.save(`${modLabel}_${seciliTarih}.pdf`);
        } catch {
            toast.error("PDF oluşturulamadı");
        } finally {
            setIslemMenuAcik(false);
        }
    };

    /* ── Checkbox ─────────────────────────────────────────── */
    const tumSecili = siralanmisListe.length > 0 && siralanmisListe.every(r => secilenler.has(r.id));
    const toggleTum = () => {
        if (tumSecili) setSecilenler(new Set());
        else setSecilenler(new Set(siralanmisListe.map(r => r.id)));
    };
    const toggleSec = (id) => {
        setSecilenler(prev => {
            const s = new Set(prev);
            s.has(id) ? s.delete(id) : s.add(id);
            return s;
        });
    };

    /* ── Alarm ────────────────────────────────────────────── */
    const alarmAc = () => {
        if (secilenler.size === 0) { toast.error("Önce hisse seçin"); return; }
        const seciliHisseler = siralanmisListe
            .filter(r => secilenler.has(r.id))
            .map(r => ({ id: r.id, hisse: r.symbol, fiyat: r.baz_fiyat }));
        setAlarmHisseler(seciliHisseler);
        setHedefFiyatlar({});
        setAlarmMail(false);
        setAlarmBildirim(true);
        setAlarmPopup(true);
        setIslemMenuAcik(false);
    };

    const alarmKaydet = async () => {
        const eksik = alarmHisseler.find(h => !hedefFiyatlar[h.hisse] || isNaN(parseFloat(hedefFiyatlar[h.hisse])));
        if (eksik) { toast.error(`${eksik.hisse} için geçerli hedef fiyat girin`); return; }
        setAlarmKaydediliyor(true);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            for (const h of alarmHisseler) {
                const fiyat = parseFloat(h.fiyat);
                const hedef = parseFloat(hedefFiyatlar[h.hisse]);
                const potansiyel = fiyat > 0 ? ((hedef - fiyat) / fiyat * 100).toFixed(2) : null;
                const { error } = await supabase.from("alerts").insert({
                    piyasa: listelenenPiyasa, sembol: h.hisse, para_birimi: "USD",
                    fiyat, hedef_fiyat: hedef,
                    potansiyel: potansiyel ? parseFloat(potansiyel) : null,
                    bildirim_mail: alarmMail, bildirim_popup: alarmBildirim,
                    user_id: session.user.id,
                });
                if (error) throw error;
            }
            toast.success(`${alarmHisseler.length} hisse için alarm eklendi!`);
            setAlarmPopup(false); setAlarmHisseler([]);
        } catch (e) { toast.error("Alarm kaydedilemedi: " + e.message); }
        finally { setAlarmKaydediliyor(false); }
    };

    /* ── Sil ──────────────────────────────────────────────── */
    const silBaslat = () => {
        if (secilenler.size === 0) { toast.error("Önce hisse seçin"); return; }
        setSilOnay(true);
        setIslemMenuAcik(false);
    };

    const silOnayla = async () => {
        setSiliyor(true);
        try {
            const token = await getToken();
            const endpoint = MODUL_ENDPOINT[listelenenModul] || "dip-tarama-analiz";
            const silIDs = siralanmisListe.filter(r => secilenler.has(r.id)).map(r => r.id);
            await axios.delete(`${API_URL}/scan/${endpoint}/sil`, {
                data: { ids: silIDs },
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success(`${silIDs.length} kayıt silindi.`);
            setSilOnay(false);
            setSecilenler(new Set());
            yukleListeData(piyasa, seciliTarih);
        } catch (e) { toast.error("Silinemedi: " + (e.response?.data?.detail || e.message)); }
        finally { setSiliyor(false); }
    };

    const basamak = listelenenPiyasa === "Kripto" ? 6 : 4;

    return (
        <>
        <div style={s.sayfa}>
            <h2 style={s.baslik}>✅ Doğruluk Analizi</h2>
            <p style={s.altBaslik}>
                Herhangi bir tarama modülünden (İşlemler menüsündeki "Doğruluk Analizine Gönder" ile) kaydettiğiniz
                sinyallerin zaman içinde ne kadar isabetli çıktığını takip eder. Seçilen hisseler, kayıt anındaki baz
                fiyata göre Aynı Gün'den +1 Yıl'a kadar farklı zaman dilimlerinde ne kadar hareket ettiğini gösterir;
                boğa sinyalleri için yükseliş, ayı sinyalleri için düşüş yönünde "başarı" sayılır. Bu sayede her
                modülün geçmiş performansını nesnel olarak ölçebilir, hangi kriterlerin gerçekten çalıştığını
                görebilirsiniz.
            </p>

            {/* Filtreler */}
            <div style={s.filtreSatiri}>
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>Modül</label>
                    <select style={s.select} value={seciliModul} onChange={e => setSeciliModul(e.target.value)}>
                        {MODULLER.map(m => (
                            <option key={m.key} value={m.key} disabled={!m.aktif}>
                                {m.label}{!m.aktif ? " (yakında)" : ""}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>Piyasa</label>
                    <select style={s.select} value={piyasa} onChange={e => setPiyasa(e.target.value)}>
                        <option value="BIST">BIST</option>
                        <option value="Kripto">Kripto</option>
                    </select>
                </div>
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>Tarih</label>
                    <select style={s.select} value={seciliTarih || ""}
                        onChange={e => setSeciliTarih(e.target.value || null)}>
                        {tarihler.length === 0 && <option value="">— kayıt yok —</option>}
                        {tarihler.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                </div>
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>&nbsp;</label>
                    <button style={{ ...s.select, background: "#2563eb", color: "white", border: "none",
                        cursor: "pointer", fontWeight: 600, opacity: (!seciliTarih || yukleniyor) ? 0.6 : 1 }}
                        onClick={listeleHandler} disabled={!seciliTarih || yukleniyor}>
                        {yukleniyor ? "Yükleniyor..." : "Listele"}
                    </button>
                </div>
            </div>

            {yukleniyor && <div style={s.yukleniyor}>Veriler yükleniyor...</div>}

            {/* ── Özet & Başarı Oranları ────────────────────── */}
            {!yukleniyor && liste.length > 0 && (() => {
                const basariRenk = (oran) => {
                    if (oran == null) return "#94a3b8";
                    return oran >= 80 ? "#16a34a" : oran >= 50 ? "#d97706" : "#dc2626";
                };
                const basariOranlari = [
                    ...DILIMLER.map(d => {
                        const verililer = filtrelenmisListe.filter(r => getHigh(r, d.key, listelenenModul) != null);
                        if (verililer.length === 0) return { label: d.label, oran: null, pozitif: 0, toplam: 0 };
                        const pozitif = verililer.filter(r => (getPct(r, d.key, listelenenModul) ?? -Infinity) > 0).length;
                        return { label: d.label, oran: Math.round(pozitif / verililer.length * 100), pozitif, toplam: verililer.length };
                    }),
                    // Bugün — anlık fiyat bazlı
                    (() => {
                        const verililer = filtrelenmisListe.filter(r => getAnlik(r, anlıkFiyatlar) != null && r.baz_fiyat);
                        if (verililer.length === 0) return { label: "Bugün", oran: null, pozitif: 0, toplam: 0 };
                        const pozitif = verililer.filter(r => {
                            const anlik = getAnlik(r, anlıkFiyatlar);
                            const baz   = parseFloat(r.baz_fiyat);
                            const ayi5  = YON_MAP[listelenenModul]?.(r) ?? false;
                            return ayi5 ? anlik < baz : anlik > baz;
                        }).length;
                        return { label: "Bugün", oran: Math.round(pozitif / verililer.length * 100), pozitif, toplam: verililer.length };
                    })(),
                ];
                return (
                    <div style={s.ozetSatir}>
                        <div style={{ ...s.ozetSayac, flexDirection: "column", alignItems: "flex-start", gap: 16 }}>
                            <div>
                                <span style={{ fontSize: 22, fontWeight: 700, color: "#93c5fd" }}>{filtrelenmisListe.length}</span>
                                <span style={{ fontSize: 13, color: "#94a3b8", marginLeft: 6 }}>
                                    {filtrelenmisListe.length !== liste.length
                                        ? `adet hisse (${liste.length} kayıttan filtrelendi)`
                                        : "adet hisse listelendi"}
                                </span>
                            </div>
                            <div style={{ position: "relative" }}>
                                <button onClick={() => setIslemMenuAcik(v => !v)}
                                    style={{ ...s.select, cursor: "pointer", fontWeight: 500,
                                        display: "flex", alignItems: "center", gap: 6, minWidth: "auto" }}>
                                    İşlemler ▾ {secilenler.size > 0 && `(${secilenler.size})`}
                                </button>
                                {islemMenuAcik && (
                                    <div style={{ ...s.menuKutu, left: 0, right: "auto" }}>
                                        {[
                                            { label: "⏰ Alarm Ekle",             aktif: true,  kirmizi: false, onClick: alarmAc  },
                                            { label: "🔎 İzleme Listesine Ekle", aktif: false, kirmizi: false, onClick: () => {} },
                                        ].map(item => (
                                            <button key={item.label}
                                                onClick={item.aktif ? item.onClick : undefined}
                                                disabled={!item.aktif}
                                                style={{ ...s.menuItem,
                                                    color: !item.aktif ? "#94a3b8" : item.kirmizi ? "#dc2626" : "#e2e8f0",
                                                    cursor: item.aktif ? "pointer" : "default" }}>
                                                {item.label}
                                            </button>
                                        ))}
                                        <IndirAltMenu onExcel={excelIndir} onCsv={csvIndir} onPdf={pdfIndir} onSvg={svgIndir} />
                                        <button onClick={silBaslat}
                                            style={{ ...s.menuItem, color: "#dc2626", cursor: "pointer", borderBottom: "none" }}>
                                            🚫 Sil
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={s.basariKutu}>
                            <div style={s.basariBaslik}>Başarı Oranları</div>
                            <div style={s.basariGrid}>
                                {basariOranlari.map(b => (
                                    <div key={b.label} style={s.basariHucre}>
                                        <div style={s.basariEtiket}>{b.label}</div>
                                        <div style={{ fontSize: 18, fontWeight: 700, color: basariRenk(b.oran) }}>
                                            {b.oran != null ? `%${b.oran}` : "—"}
                                        </div>
                                        {b.toplam > 0 && <div style={s.basariN}>{b.pozitif} hisse</div>}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {(() => {
                            // Baz fiyatı olan hisseler
                            const bazlilar = filtrelenmisListe.filter(r => r.baz_fiyat && r.baz_fiyat > 0);
                            if (bazlilar.length === 0) return null;

                            // TL fiyatları USD'ye çevirmek için kur
                            const kur = usdTryKur || 1;
                            const tlMi = (r) => r.para_birimi && (r.para_birimi.includes("TL") || r.para_birimi === "TL");
                            const toUSD = (fiyat, r) => fiyat != null
                                ? (tlMi(r) ? parseFloat(fiyat) / kur : parseFloat(fiyat))
                                : null;

                            // Toplam maliyet: her hisseden 1 adet × baz fiyat (USD bazlı)
                            const toplamMaliyet = bazlilar.reduce((s, r) =>
                                s + (toUSD(r.baz_fiyat, r) || 0), 0);

                            // Şu anki değer: anlık fiyatlar tablosundan (USD bazlı)
                            const suankiDeger = bazlilar.reduce((s, r) => {
                                const anlikHam = getAnlik(r, anlıkFiyatlar);
                                const bazU     = toUSD(r.baz_fiyat, r) || 0;
                                // anlık fiyatı USD'ye çevir (TL ise kura böl)
                                const anlikUSD = anlikHam == null ? null
                                    : (tlMi(r) ? anlikHam / kur : anlikHam);
                                const ayi7  = YON_MAP[listelenenModul]?.(r) ?? false;
                                if (anlikUSD == null) return s + bazU;
                                return ayi7 ? s + (2 * bazU - anlikUSD) : s + anlikUSD;
                            }, 0);

                            // En yüksek kazanç: ayı için min low, boğa için max high
                            const enYuksekDeger = bazlilar.reduce((s, r) => {
                                const ayi6 = YON_MAP[listelenenModul]?.(r) ?? false;
                                if (ayi6) {
                                    const lows = DILIMLER.map(d => r[`${d.key}_low`]).filter(v => v != null);
                                    const lows_usd = lows.map(l => tlMi(r) ? l / kur : l);
                                    // Ayı: en düşük fiyata ulaşıldıysa kazanç = baz - min_low
                                    const minLow = lows_usd.length > 0 ? Math.min(...lows_usd) : (toUSD(r.baz_fiyat, r) || 0);
                                    const bazUSD = toUSD(r.baz_fiyat, r) || 0;
                                    return s + (bazUSD - minLow + bazUSD); // sanki "değer" bazUSD - (bazUSD - minLow) = minLow'dur
                                } else {
                                    const highs = DILIMLER.map(d => r[`${d.key}_high`]).filter(v => v != null);
                                    const highs_usd = highs.map(h => tlMi(r) ? h / kur : h);
                                    const maxHigh = highs_usd.length > 0 ? Math.max(...highs_usd) : (toUSD(r.baz_fiyat, r) || 0);
                                    return s + maxHigh;
                                }
                            }, 0);

                            const suankiKazanc = suankiDeger - toplamMaliyet;
                            const suankiPct    = toplamMaliyet > 0 ? (suankiKazanc / toplamMaliyet * 100).toFixed(2) : 0;
                            const enYuksekKazanc = enYuksekDeger - toplamMaliyet;
                            const enYuksekPct    = toplamMaliyet > 0 ? (enYuksekKazanc / toplamMaliyet * 100).toFixed(2) : 0;

                            const fmtUSD = v => {
                                const n = parseFloat(v);
                                if (Math.abs(n) >= 1000) return n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                if (Math.abs(n) >= 1) return n.toFixed(4);
                                return n.toFixed(6);
                            };

                            return (
                                <div style={{ ...s.basariKutu, flex: "0 0 auto" }}>
                                    <div style={s.basariBaslik}>Tahmini Kazanç</div>
                                    <div style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 11, whiteSpace: "nowrap" }}>
                                        {[
                                            { label: "💰 Toplam Maliyet", val: `$${fmtUSD(toplamMaliyet)}`, extra: null, renk: "#e2e8f0" },
                                            { label: "📊 Şu Anki Kazanç", val: `${suankiKazanc>=0?"+":""}$${fmtUSD(suankiKazanc)}`, extra: `(${suankiKazanc>=0?"+":""}${suankiPct}%)`, renk: suankiKazanc>=0?"#16a34a":"#dc2626" },
                                            { label: "🚀 En Yüksek Kazanç", val: `${enYuksekKazanc>=0?"+":""}$${fmtUSD(enYuksekKazanc)}`, extra: `(${enYuksekKazanc>=0?"+":""}${enYuksekPct}%)`, renk: enYuksekKazanc>=0?"#16a34a":"#dc2626" },
                                        ].map(({ label, val, extra, renk }) => (
                                            <div key={label} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                                <span style={{ color: "#94a3b8", minWidth: 120 }}>{label} :</span>
                                                <strong style={{ color: renk }}>{val}</strong>
                                                {extra && <span style={{ color: renk, fontSize: 10 }}>{extra}</span>}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                );
            })()}

            {/* MFE/MAE Paneli */}
            {!yukleniyor && liste.length > 0 && MFE_MODULLER.has(listelenenModul) && (() => {
                const dilimler = MFE_DILIMLER;
                const hesapla = (dilKey) => {
                    const satirlar = filtrelenmisListe.filter(r =>
                        r[`mfe_${dilKey}`] != null || r[`hedef_vuruldu_${dilKey}`] != null
                    );
                    if (!satirlar.length) return null;
                    const hedefVuruldu = satirlar.filter(r => r[`hedef_vuruldu_${dilKey}`] === true).length;
                    const stopVuruldu  = satirlar.filter(r => r[`hedef_vuruldu_${dilKey}`] === false).length;
                    const hicVurulmadi = satirlar.filter(r => r[`hedef_vuruldu_${dilKey}`] == null).length;
                    const mfelilar     = satirlar.filter(r => r[`mfe_${dilKey}`] != null);
                    const maelilar     = satirlar.filter(r => r[`mae_${dilKey}`] != null);
                    const ortMfe = mfelilar.length
                        ? (mfelilar.reduce((s,r) => s + r[`mfe_${dilKey}`], 0) / mfelilar.length).toFixed(1)
                        : null;
                    const ortMae = maelilar.length
                        ? (maelilar.reduce((s,r) => s + r[`mae_${dilKey}`], 0) / maelilar.length).toFixed(1)
                        : null;
                    const n = satirlar.length;
                    return { n, hedefVuruldu, stopVuruldu, hicVurulmadi,
                             hedefPct: Math.round(hedefVuruldu / n * 100),
                             stopPct:  Math.round(stopVuruldu  / n * 100),
                             bekPct:   Math.round(hicVurulmadi / n * 100),
                             ortMfe, ortMae };
                };
                const herhangiVeri = dilimler.some(d => hesapla(d.key) !== null);
                if (!herhangiVeri) return null;

                const InfoIcon = ({ alan }) => (
                    <span
                        onMouseEnter={e => {
                            const r = e.currentTarget.getBoundingClientRect();
                            setMfeTooltip({ alan, x: r.left + r.width / 2, y: r.top });
                        }}
                        onMouseLeave={() => setMfeTooltip(null)}
                        style={{ cursor: "help", color: "#94a3b8", fontSize: 10,
                            marginLeft: 3, display: "inline-flex", alignItems: "center",
                            background: "#334155", borderRadius: "50%", width: 14, height: 14,
                            justifyContent: "center", fontWeight: 700, flexShrink: 0,
                            userSelect: "none", fontStyle: "italic" }}>
                        i
                    </span>
                );

                return (
                    <div style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: 12,
                        padding: "12px 20px", marginBottom: 12 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#e2e8f0", marginBottom: 12, display: "flex", alignItems: "center", gap: 6 }}>
                            🎯 İşlem-Bazlı Sonuç (MFE/MAE) — Hedef ve Stop'a Göre
                            <InfoIcon alan="MFE/MAE" />
                        </div>
                        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                            {dilimler.map(d => {
                                const h = hesapla(d.key);
                                if (!h) return (
                                    <div key={d.key} style={{ flex: "0 0 auto", minWidth: 130,
                                        background: "#0f172a", borderRadius: 8, padding: "10px 14px",
                                        border: "1px solid #334155" }}>
                                        <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 4, fontWeight: 700 }}>{d.label}</div>
                                        <div style={{ fontSize: 11, color: "#475569" }}>Henüz veri yok</div>
                                    </div>
                                );
                                return (
                                    <div key={d.key} style={{ flex: "0 0 auto", minWidth: 130,
                                        background: "#0f172a", borderRadius: 8, padding: "10px 14px",
                                        border: "1px solid #334155" }}>
                                        <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 8, fontWeight: 700 }}>{d.label}</div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 12 }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                <span style={{ color: "#4ade80", display: "flex", alignItems: "center" }}>✅ Hedef<InfoIcon alan="Hedef"/></span>
                                                <strong style={{ color: "#4ade80" }}>{h.hedefPct}%</strong>
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                <span style={{ color: "#f87171", display: "flex", alignItems: "center" }}>🛑 Stop<InfoIcon alan="Stop"/></span>
                                                <strong style={{ color: "#f87171" }}>{h.stopPct}%</strong>
                                            </div>
                                            {h.hicVurulmadi > 0 && (
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                    <span style={{ color: "#94a3b8", display: "flex", alignItems: "center" }}>⏳ Bekliyor<InfoIcon alan="Bekliyor"/></span>
                                                    <strong style={{ color: "#94a3b8" }}>{h.bekPct}%</strong>
                                                </div>
                                            )}
                                            <div style={{ borderTop: "1px solid #334155", marginTop: 4, paddingTop: 4 }}>
                                                {h.ortMfe != null && (
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                        <span style={{ color: "#94a3b8", display: "flex", alignItems: "center" }}>Ort MFE<InfoIcon alan="Ort MFE"/></span>
                                                        <span style={{ color: "#4ade80", fontWeight: 600 }}>+{h.ortMfe}%</span>
                                                    </div>
                                                )}
                                                {h.ortMae != null && (
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                        <span style={{ color: "#94a3b8", display: "flex", alignItems: "center" }}>Ort MAE<InfoIcon alan="Ort MAE"/></span>
                                                        <span style={{ color: "#f87171", fontWeight: 600 }}>-{h.ortMae}%</span>
                                                    </div>
                                                )}
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                    <span style={{ color: "#475569", display: "flex", alignItems: "center" }}>n<InfoIcon alan="n"/></span>
                                                    <span style={{ color: "#64748b" }}>{h.n}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })()}

            {/* Filtre Kartı: modüle göre değişen kriterler */}
            {!yukleniyor && liste.length > 0 && MODUL_FILTRE_ALANLARI[listelenenModul] && (() => {
                const alanlar = MODUL_FILTRE_ALANLARI[listelenenModul];
                const filtreAktif = alanlar.some(f => !f.sabit && (modulFiltreleri[f.alan]?.size || 0) > 0);
                return (
                    <div style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: 12,
                        padding: "12px 20px", marginBottom: 12, display: "flex", gap: 20, flexWrap: "wrap", alignItems: "center" }}>

                        {alanlar.map((f, i) => (
                            <div key={f.alan} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                {i > 0 && <div style={{ width: 1, height: 20, background: "#334155" }} />}
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em" }}>{f.etiket}</span>
                                    {f.sabit ? (
                                        <button disabled style={{
                                            padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 700,
                                            border: `2px solid ${f.renk}`, background: f.renk + "22", color: f.renk, cursor: "default",
                                        }}>{listelenenPiyasa}</button>
                                    ) : (
                                        [...new Set(liste.map(r => r[f.alan]).filter(v => v != null && v !== ""))]
                                            .sort((a, b) => typeof a === "number" && typeof b === "number" ? a - b : String(a).localeCompare(String(b), "tr"))
                                            .map(v => {
                                                const aktif = modulFiltreleri[f.alan]?.has(v);
                                                return (
                                                    <button key={v} onClick={() => toggleModulFiltre(f.alan, v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: aktif ? 700 : 400,
                                                        border: `2px solid ${aktif ? f.renk : "#334155"}`,
                                                        background: aktif ? f.renk + "22" : "transparent",
                                                        color: aktif ? f.renk : "#94a3b8",
                                                    }}>{f.onEk || ""}{v}</button>
                                                );
                                            })
                                    )}
                                </div>
                            </div>
                        ))}

                        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
                            <span style={{ fontSize: 12, color: "#94a3b8" }}>
                                <strong style={{ color: "#e2e8f0" }}>{filtrelenmisListe.length}</strong> / {liste.length} sonuç
                            </span>
                            {filtreAktif && (
                                <button onClick={() => setModulFiltreleri({})}
                                    style={{ padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                        border: "1px solid #dc262666", background: "#dc262611", color: "#dc2626" }}>
                                    ✕ Temizle
                                </button>
                            )}
                        </div>
                    </div>
                );
            })()}

            {!yukleniyor && tarihler.length === 0 && (
                <div style={s.bos}>
                    <p style={{ fontSize: 15, fontWeight: 500, marginBottom: 8 }}>Henüz kayıt yok</p>
                    <p style={{ fontSize: 13, color: "#94a3b8" }}>
                        {MODUL_BOS_MESAJ[seciliModul] || "Tarama sayfasında hisse seçip"} <strong>İşlemler → ✅ Doğruluk Analizi</strong> ile kayıt ekleyin.
                    </p>
                </div>
            )}

            {!yukleniyor && liste.length > 0 && (
                <div style={{ overflowX: "auto", border: "1px solid #334155", borderRadius: 12, background: "#1e293b" }}
                    onClick={() => islemMenuAcik && setIslemMenuAcik(false)}>
                    <table style={s.tablo}>
                        <thead>
                            <tr style={s.thead}>
                                {/* Checkbox başlık */}
                                <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                                    <input type="checkbox" checked={tumSecili} onChange={toggleTum}
                                        title="Tümünü seç"
                                        style={{ cursor: "pointer", width: 15, height: 15 }} />
                                </th>
                                {aktifKolonlar.map(({ label, kol }) => (
                                    <th key={kol} onClick={() => siralamaToggle(kol)}
                                        style={{ ...s.th, cursor: "pointer", userSelect: "none" }}>
                                        {label} {siralamaKol === kol ? (siralamaYon === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                ))}
                                {dipSutunlar.map(k => (
                                    <th key={k} onClick={() => siralamaToggle(k)}
                                        style={{ ...s.th, cursor: "pointer", userSelect: "none" }}>
                                        {k} {siralamaKol === k ? (siralamaYon === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                ))}
                                {DILIMLER.map(d => (
                                    <th key={d.key} onClick={() => siralamaToggle(`${d.key}_pct`)}
                                        style={{ ...s.th, cursor: "pointer", userSelect: "none",
                                            borderLeft: d.key === "d0" ? "2px solid rgba(255,255,255,0.3)" : undefined }}>
                                        {d.label} {siralamaKol === `${d.key}_pct` ? (siralamaYon === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                ))}
                                <th onClick={() => siralamaToggle("bugun_pct")}
                                    style={{ ...s.th, cursor: "pointer", userSelect: "none",
                                        borderLeft: "2px solid rgba(255,255,255,0.3)", background: "#16a34a" }}>
                                    Bugün {siralamaKol === "bugun_pct" ? (siralamaYon === "asc" ? "↑" : "↓") : ""}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {siralanmisListe.map((row, i) => (
                                <>
                                    <tr key={row.id || i}
                                        onClick={() => yukleGrafik(row)}
                                        style={{ cursor: "pointer", background: secilenler.has(row.id) ? "#3b82f622" : i % 2 === 0 ? "#1e293b" : "#182234" }}>
                                        {/* Checkbox */}
                                        <td style={{ ...s.td, textAlign: "center" }}
                                            onClick={e => e.stopPropagation()}>
                                            <input type="checkbox" checked={secilenler.has(row.id)}
                                                onChange={() => toggleSec(row.id)}
                                                style={{ cursor: "pointer", width: 15, height: 15 }} />
                                        </td>
                                        {/* Hisse */}
                                        {aktifKolonlar.map(({ kol }) => {
                                            if (kol === "symbol") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 700, color: "#2563eb" }}>
                                                    {row.symbol}
                                                </td>
                                            );
                                            if (kol === "kalite") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.kalite?.includes("Yüksek") ? "#16a34a"
                                                         : row.kalite?.includes("Orta") ? "#d97706" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "trend") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.trend === "LONG" ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "ema200") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}
                                                </td>
                                            );
                                            if (kol === "moduller") return (
                                                <td key={kol} style={{ ...s.td, fontSize: 11 }}>
                                                    {row[kol] ? row[kol].split(",").map((m,i) => (
                                                        <span key={i} style={{display:"inline-block",background:"#3b82f622",
                                                            color:"#2563eb",borderRadius:4,padding:"1px 6px",
                                                            margin:"1px 2px",fontSize:10}}>{m.trim()}</span>
                                                    )) : "—"}
                                                </td>
                                            );
                                            if (kol === "modul_sayisi") return (
                                                <td key={kol} style={{...s.td, textAlign:"center", fontWeight:700,
                                                    color:"#2563eb"}}>
                                                    {row[kol] ?? "—"}
                                                </td>
                                            );
                                            if (kol === "trend") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.trend === "LONG" ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "ema200") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}
                                                </td>
                                            );
                                            if (kol === "moduller") return (
                                                <td key={kol} style={{ ...s.td, fontSize: 11, color: "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "islem_tipi") return (
                                                <td key={kol} style={{ ...s.td, fontSize: 11 }}>{row[kol] || "—"}</td>
                                            );
                                            if (kol === "yil_low" || kol === "ceyrek_acilis" || kol === "aylik_acilis" || kol === "haftalik_acilis") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}
                                                </td>
                                            );
                                            if (kol === "konfidans") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 700,
                                                    color: (row[kol]||0) >= 85 ? "#16a34a"
                                                         : (row[kol]||0) >= 70 ? "#2563eb"
                                                         : (row[kol]||0) >= 50 ? "#d97706" : "#dc2626" }}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(1) : "—"}
                                                </td>
                                            );
                                            if (kol === "kademe") return (
                                                <td key={kol} style={{ ...s.td }}>
                                                    <span style={{ padding:"2px 8px", borderRadius:12, fontSize:11, fontWeight:700,
                                                        background: row.kademe?.includes("Çok") ? "#16a34a22"
                                                                  : row.kademe?.includes("Yüksek") ? "#3b82f622"
                                                                  : row.kademe?.includes("Orta") ? "#f59e0b22" : "#dc262622",
                                                        color: row.kademe?.includes("Çok") ? "#16a34a"
                                                             : row.kademe?.includes("Yüksek") ? "#2563eb"
                                                             : row.kademe?.includes("Orta") ? "#d97706" : "#dc2626" }}>
                                                        {row[kol] || "—"}
                                                    </span>
                                                </td>
                                            );
                                            if (kol === "yon") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 700,
                                                    color: row.yon === "ALIŞ" ? "#16a34a"
                                                         : row.yon === "SATIŞ" ? "#dc2626" : "#94a3b8" }}>
                                                    {row.yon === "ALIŞ" ? "▲ ALIŞ" : row.yon === "SATIŞ" ? "▼ SATIŞ" : "— NÖTR"}
                                                </td>
                                            );
                                            if (kol === "sektorel_momentum" || kol === "haber_duygu_skoru" || kol === "risk_skoru") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: (row[kol]||0) > 50 ? "#16a34a" : (row[kol]||0) < 50 ? "#dc2626" : "#94a3b8" }}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(1) : "—"}
                                                </td>
                                            );
                                            if (kol === "tip") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.tip?.includes("Bearish") ? "#dc2626" : "#16a34a" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "konfluence_skoru") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 700,
                                                    color: (row[kol]||0) >= 75 ? "#16a34a"
                                                         : (row[kol]||0) >= 50 ? "#d97706" : "#dc2626" }}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(0) : "—"}
                                                </td>
                                            );
                                            if (kol === "ha_skoru") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 700,
                                                    color: (row[kol]||0) >= 60 ? "#16a34a"
                                                         : (row[kol]||0) >= 35 ? "#d97706" : "#dc2626" }}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(0) : "—"}
                                                </td>
                                            );
                                            if (kol === "spike_katsayisi" || kol === "momentum") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(2) : "—"}
                                                </td>
                                            );
                                            if (kol === "poc" || kol === "vah" || kol === "val" || kol === "baz_fiyat") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}
                                                </td>
                                            );
                                            if (kol === "va_durum") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.va_durum?.includes("İçinde") ? "#16a34a"
                                                         : row.va_durum?.includes("Üstünde") ? "#dc2626"
                                                         : row.va_durum?.includes("Altında") ? "#2563eb" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "sinyal") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.sinyal?.includes("Al") ? "#16a34a"
                                                         : row.sinyal?.includes("Sat") ? "#dc2626" : "#d97706" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "hacim_yogunluk_skoru") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 700,
                                                    color: (row[kol]||0) >= 70 ? "#16a34a"
                                                         : (row[kol]||0) >= 50 ? "#d97706" : "#dc2626" }}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(0) : "—"}
                                                </td>
                                            );
                                            if (kol === "poc_uzaklik_pct" || kol === "poc_hacim_pct") return (
                                                <td key={kol} style={{ ...s.td,
                                                    color: kol === "poc_uzaklik_pct" && Math.abs(row[kol]||999) <= 2 ? "#16a34a" : "#e2e8f0" }}>
                                                    {row[kol] != null ? `${kol==="poc_uzaklik_pct" && row[kol]>0 ? "+" : ""}${Number(row[kol]).toFixed(1)}%` : "—"}
                                                </td>
                                            );
                                            if (kol === "poc") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}
                                                </td>
                                            );
                                            if (kol === "va_durum") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.va_durum?.includes("İçinde") ? "#16a34a"
                                                         : row.va_durum?.includes("Üstünde") ? "#dc2626"
                                                         : row.va_durum?.includes("Altında") ? "#2563eb" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "giris_skoru") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 700,
                                                    color: row.giris_skoru >= 80 ? "#15803d"
                                                         : row.giris_skoru >= 65 ? "#2563eb"
                                                         : row.giris_skoru >= 50 ? "#d97706" : "#dc2626" }}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(0) : "—"}
                                                </td>
                                            );
                                            if (kol === "karar") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.karar?.includes("GÜÇLÜ AL") ? "#15803d"
                                                         : row.karar?.includes("AL") ? "#2563eb"
                                                         : row.karar?.includes("İZLE") ? "#d97706"
                                                         : row.karar?.includes("DİKKAT") ? "#ea580c" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "guven_skoru") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 700,
                                                    color: row.guven_skoru >= 80 ? "#16a34a"
                                                         : row.guven_skoru >= 60 ? "#d97706" : "#dc2626" }}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(0) : "—"}
                                                </td>
                                            );
                                            if (kol === "yon") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.yon?.includes("Yüksel") || row.yon?.includes("Long") || row.yon?.includes("Al") ? "#16a34a"
                                                         : row.yon?.includes("Düş") || row.yon?.includes("Short") || row.yon?.includes("Sat") ? "#dc2626" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "hedef_alt" || kol === "hedef_ust" || kol === "stop") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}
                                                </td>
                                            );
                                            if (kol === "rr_orani") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 500 }}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(2) : "—"}
                                                </td>
                                            );
                                            if (kol === "killzone") return (
                                                <td key={kol} style={{ ...s.td, fontSize: 11, fontWeight: 500 }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "yapi_tipi") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.yapi_tipi?.includes("Boğa") || row.yapi_tipi?.includes("FVG") ? "#16a34a"
                                                         : row.yapi_tipi?.includes("Ayı") ? "#dc2626" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "sinif") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.sinif?.includes("A") ? "#16a34a"
                                                         : row.sinif?.includes("B") ? "#d97706" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "smt_tipi") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.smt_tipi?.includes("Boğa") ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "hisse_swing" || kol === "referans_swing") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}
                                                </td>
                                            );
                                            if (kol === "korelasyon") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? `${Number(row[kol]).toFixed(2)}%` : "—"}
                                                </td>
                                            );
                                            if (kol === "bolge") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.bolge?.includes("Discount") ? "#16a34a"
                                                         : row.bolge?.includes("Premium") ? "#dc2626" : "#d97706" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "yon_onerisi") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.yon_onerisi?.includes("Al") ? "#16a34a"
                                                         : row.yon_onerisi?.includes("Sat") ? "#dc2626" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "fib_pct" || kol === "delta_vol_pct") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? `${Number(row[kol]).toFixed(2)}%` : "—"}
                                                </td>
                                            );
                                            if (kol === "idm_tipi") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.idm_tipi?.includes("Boğa") ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "idm_seviyesi" || kol === "sonraki_hedef") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}
                                                </td>
                                            );
                                            if (kol === "pullback_sayisi") return (
                                                <td key={kol} style={{ ...s.td, textAlign: "center" }}>
                                                    {row[kol] ?? "—"}
                                                </td>
                                            );
                                            if (kol === "ob_tipi") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.ob_tipi?.includes("Boğa") ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "guc") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.guc?.includes("Yüksek") ? "#16a34a"
                                                         : row.guc?.includes("Orta") ? "#d97706" : "#94a3b8" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "fvg_onayi" || kol === "displacement" || kol === "tazelik") return (
                                                <td key={kol} style={{ ...s.td, fontSize: 12 }}>{row[kol] || "—"}</td>
                                            );
                                            if (kol === "ote_tipi") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.ote_tipi?.includes("Boğa") ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "fib_seviye_pct" || kol === "rr_orani") return (
                                                <td key={kol} style={s.td}>
                                                    {row[kol] != null ? Number(row[kol]).toFixed(2) : "—"}
                                                </td>
                                            );
                                            if (kol === "msb_tipi") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.msb_tipi?.includes("Boğa") ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "kirilan_seviye") return (
                                                <td key={kol} style={s.td}>{row[kol] != null ? Number(row[kol]).toFixed(basamak) : "—"}</td>
                                            );
                                            if (kol === "guclu_kirilim") return (
                                                <td key={kol} style={{ ...s.td,
                                                    color: row.guclu_kirilim?.includes("Evet") ? "#16a34a" : "#94a3b8",
                                                    fontWeight: 500 }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "temas_sayisi") return (
                                                <td key={kol} style={{ ...s.td, textAlign: "center", fontWeight: 600 }}>
                                                    {row[kol] ?? "—"}
                                                </td>
                                            );
                                            if (kol === "capa_durum") return (
                                                <td key={kol} style={{ ...s.td, fontSize: 11 }}>
                                                    <span style={{
                                                        background: row.capa_durum?.includes("Aktif") ? "#16a34a22" : "#334155",
                                                        color: row.capa_durum?.includes("Aktif") ? "#16a34a" : "#e2e8f0",
                                                        borderRadius: 4, padding: "2px 6px",
                                                    }}>{row[kol] || "—"}</span>
                                                </td>
                                            );
                                            if (kol === "fvg_tip") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.fvg_tip?.includes("Boğa") ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "sweep_tipi") return (
                                                <td key={kol} style={{ ...s.td, fontWeight: 600,
                                                    color: row.sweep_tipi?.includes("Boğa") ? "#16a34a" : "#dc2626" }}>
                                                    {row[kol] || "—"}
                                                </td>
                                            );
                                            if (kol === "baz_fiyat" || kol === "dip_fiyat" || kol === "referans_seviye") return (
                                                <td key={kol} style={s.td}>{fmt(row[kol], basamak)}</td>
                                            );
                                            if (kol === "fark_pct") return (
                                                <td key={kol} style={{ ...s.td, color: pctRenk(row.fark_pct) }}>
                                                    {row.fark_pct != null ? `${parseFloat(row.fark_pct).toFixed(2)}%` : "—"}
                                                </td>
                                            );
                                            return <td key={kol} style={s.td}>{row[kol] ?? "—"}</td>;
                                        })}
                                        {dipSutunlar.map(k => (
                                            <td key={k} style={s.td}>{row[k] ?? "—"}</td>
                                        ))}
                                        {DILIMLER.map(d => {
                                            const high = getHigh(row, d.key, listelenenModul);
                                            const pct  = getPct(row, d.key, listelenenModul);
                                            return (
                                                <td key={d.key} style={{ ...s.td,
                                                    borderLeft: d.key === "d0" ? "2px solid #334155" : undefined }}>
                                                    {high != null ? (
                                                        <>
                                                            <div style={{ fontWeight: 500 }}>{fmt(high, basamak)}</div>
                                                            <div style={{ fontSize: 11, color: pctRenk(pct) }}>
                                                                {pct != null ? `(${pct > 0 ? "+" : ""}${parseFloat(pct).toFixed(2)}%)` : ""}
                                                            </div>
                                                        </>
                                                    ) : <span style={{ color: "#94a3b8" }}>—</span>}
                                                </td>
                                            );
                                        })}
                                        {/* Bugün kolonu */}
                                        {(() => {
                                            const anlik = getAnlik(row, anlıkFiyatlar);
                                            if (anlik == null) return (
                                                <td key="bugun" style={{ ...s.td, borderLeft: "2px solid #22c55e", background: "#22c55e26", color: "#94a3b8" }}>—</td>
                                            );
                                            const ayi8 = YON_MAP[listelenenModul]?.(row) ?? false;
                                            // anlik getAnlik() ile alındı — zaten doğru para biriminde (TL veya USD)
                                            // baz_fiyat da aynı para biriminde saklandı
                                            const baz = row.baz_fiyat ? parseFloat(row.baz_fiyat) : null;
                                            // Boğa: (anlik - baz) / baz * 100
                                            // Ayı:  (baz - anlik) / baz * 100
                                            const pct2 = baz && baz > 0
                                                ? (ayi8 ? (baz - anlik) / baz * 100 : (anlik - baz) / baz * 100)
                                                : null;
                                            const pozitif = pct2 != null && pct2 > 0;
                                            return (
                                                <td key="bugun" style={{ ...s.td, borderLeft: "2px solid #22c55e", background: "#22c55e26",
                                                    color: pct2 == null ? "#94a3b8" : pozitif ? "#16a34a" : "#dc2626",
                                                    fontWeight: 600 }}>
                                                    <div>{fmt(anlik, basamak)}</div>
                                                    {pct2 != null && (
                                                        <div style={{ fontSize: 11 }}>
                                                            ({pozitif ? "+" : ""}{pct2.toFixed(2)}%)
                                                        </div>
                                                    )}
                                                </td>
                                            );
                                        })()}
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {!yukleniyor && seciliTarih && liste.length === 0 && tarihler.length > 0 && (
                <div style={s.bos}>Bu tarih için kayıt bulunamadı.</div>
            )}

            {/* ── Grafik Popup ─────────────────────────────────── */}
            {grafikPopupRow && (
                <div style={s.overlay} onClick={() => setGrafikPopupRow(null)}>
                    <div style={{ ...s.popup, width: 860, maxWidth: "95vw" }} onClick={e => e.stopPropagation()}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                            <div>
                                <h3 style={{ ...s.popupBaslik, margin: 0 }}>{grafikPopupRow.symbol}</h3>
                                <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
                                    Ekleme tarihinden bugüne en yüksek fiyat
                                    <span style={{ marginLeft: 8 }}>
                                        Baz: {fmt(grafikPopupRow.baz_fiyat, basamak)} {grafikPopupRow.para_birimi}
                                    </span>
                                </div>
                            </div>
                            <button onClick={() => setGrafikPopupRow(null)}
                                style={{ background: "none", border: "none", color: "#94a3b8", fontSize: 20, cursor: "pointer", padding: 4 }}>✕</button>
                        </div>
                        {grafikYukleniyor ? (
                            <div style={{ textAlign: "center", padding: 30, color: "#94a3b8" }}>Grafik yükleniyor...</div>
                        ) : grafikVeri.length === 0 ? (
                            <div style={{ textAlign: "center", padding: 30, color: "#94a3b8" }}>Henüz fiyat verisi yok.</div>
                        ) : (
                            <SvgGrafik veri={grafikVeri} bazFiyat={grafikPopupRow.baz_fiyat} basamak={basamak} />
                        )}
                    </div>
                </div>
            )}

            {/* ── Alarm Popup ─────────────────────────────────── */}
            {alarmPopup && (
                <div style={s.overlay}>
                    <div style={{ ...s.popup, width: 420 }}>
                        <h3 style={s.popupBaslik}>⏰ Alarm Ekle</h3>
                        <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 12 }}>
                            Piyasa: <strong>{piyasa}</strong>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {alarmHisseler.map(h => {
                                const hedef = hedefFiyatlar[h.hisse] || "";
                                const fiyat = parseFloat(h.fiyat);
                                const hedefN = parseFloat(hedef);
                                const pct = hedef && !isNaN(hedefN) && fiyat > 0
                                    ? ((hedefN - fiyat) / fiyat * 100).toFixed(2) : null;
                                return (
                                    <div key={h.hisse} style={{ background: "#182234", borderRadius: 8, padding: "10px 12px", border: "1px solid #334155" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                                            <strong style={{ fontSize: 14 }}>{h.hisse}</strong>
                                            <span style={{ color: "#94a3b8", fontSize: 12 }}>Baz: {fmt(h.fiyat, basamak)}</span>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <span style={{ color: "#94a3b8", fontSize: 12, minWidth: 80 }}>Hedef Fiyat:</span>
                                            <input type="number" value={hedef}
                                                onChange={e => setHedefFiyatlar(prev => ({ ...prev, [h.hisse]: e.target.value }))}
                                                style={{ flex: 1, padding: "4px 8px", borderRadius: 6, border: "1px solid #475569", fontSize: 13, textAlign: "right" }}
                                                placeholder="0.00" />
                                            {pct !== null && (
                                                <span style={{ fontSize: 12, fontWeight: 600, color: parseFloat(pct) >= 0 ? "#16a34a" : "#dc2626", minWidth: 52 }}>
                                                    {parseFloat(pct) >= 0 ? "+" : ""}{pct}%
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div style={{ marginTop: 12 }}>
                            <div style={{ color: "#94a3b8", marginBottom: 6, fontSize: 12 }}>Bildirim Tercihi:</div>
                            <div style={{ display: "flex", gap: 16 }}>
                                {[["Mail", alarmMail, setAlarmMail], ["Pop-up", alarmBildirim, setAlarmBildirim]].map(([ad, val, setter]) => (
                                    <label key={ad} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 13 }}>
                                        <input type="checkbox" checked={val} onChange={e => setter(e.target.checked)} /> {ad}
                                    </label>
                                ))}
                            </div>
                        </div>
                        <div style={s.popupButonlar}>
                            <button onClick={() => { setAlarmPopup(false); setAlarmHisseler([]); }}
                                style={s.btnIptal}>Vazgeç</button>
                            <button onClick={alarmKaydet} disabled={alarmKaydediliyor}
                                style={{ ...s.btnOnay, background: alarmKaydediliyor ? "#94a3b8" : "#1e3a5f" }}>
                                {alarmKaydediliyor ? "Kaydediliyor..." : "Kaydet"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Silme Onay Popup ─────────────────────────────── */}
            {silOnay && (
                <div style={s.overlay}>
                    <div style={{ ...s.popup, width: 360 }}>
                        <h3 style={{ ...s.popupBaslik, color: "#dc2626" }}>🚫 Kayıtları Sil</h3>
                        <p style={{ fontSize: 14, color: "#e2e8f0", margin: "12px 0 20px" }}>
                            Seçili <strong>{secilenler.size}</strong> kayıt kalıcı olarak silinecek.
                            Bu işlem geri alınamaz. Emin misiniz?
                        </p>
                        <div style={s.popupButonlar}>
                            <button onClick={() => setSilOnay(false)} style={s.btnIptal}>Vazgeç</button>
                            <button onClick={silOnayla} disabled={siliyor}
                                style={{ ...s.btnOnay, background: siliyor ? "#94a3b8" : "#dc2626" }}>
                                {siliyor ? "Siliniyor..." : "Evet, Sil"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
        {/* MFE/MAE Bilgi Tooltip */}
        {mfeTooltip && (() => {
            const ACIKLAMALAR_T = {
                "MFE/MAE": "İşlem-bazlı sonuç ölçümü. Sinyal kaydından itibaren fiyat önce hedefe mi ulaştı, yoksa stop'u mu tetikledi? Klasik 'fiyat yükseldi mi?' sorusu yerine gerçek işlem sonucunu ölçer.",
                "Hedef": "Hedef fiyata stop fiyattan önce ulaşılan sinyal oranı. Yüksek olması sinyalin gerçek işlemde karlı olduğunu gösterir.",
                "Stop": "Stop fiyatı hedef fiyattan önce tetiklenen sinyal oranı. Gerçek işlemde zarara uğrayan sinyaller.",
                "Bekliyor": "Dilim süresi dolduğunda henüz ne hedef ne de stop vurulmamış sinyaller. Pozisyon hâlâ açık anlamına gelir.",
                "Ort MFE": "Ortalama Maksimum Lehte Hareket. Sinyal yönünde en fazla ne kadar kâr fırsatı oluştu? Yüksek MFE, sinyalin doğru yönde güçlü hareket ettiğini gösterir.",
                "Ort MAE": "Ortalama Maksimum Aleyhte Hareket. Sinyal aleyhine en fazla ne kadar geriledi? Düşük MAE, sinyalin az stres yarattığını gösterir.",
                "n": "Hesaplamaya dahil edilen sinyal sayısı. Hedef veya stop bilgisi olan ve dilim süresi dolan kayıtlar dahil edilir.",
            };
            const tooltipW = 240;
            const left = Math.max(8, Math.min(mfeTooltip.x - tooltipW / 2, window.innerWidth - tooltipW - 8));
            return (
                <div style={{
                    position: "fixed",
                    left, top: Math.max(8, mfeTooltip.y - 8),
                    transform: "translateY(-100%)",
                    width: tooltipW, zIndex: 9999,
                    background: "#0f172a", border: "1px solid #3b82f6",
                    borderRadius: 10, padding: "10px 14px",
                    fontSize: 12, color: "#cbd5e1", lineHeight: 1.6,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.6)",
                    pointerEvents: "none",
                }}>
                    <div style={{ fontWeight: 700, color: "#e2e8f0", marginBottom: 6, fontSize: 13 }}>
                        {mfeTooltip.alan}
                    </div>
                    {ACIKLAMALAR_T[mfeTooltip.alan]}
                </div>
            );
        })()}
    </>
    );
}

const s = {
    sayfa:        { padding: "1.5rem", background: "#0f172a", minHeight: "100vh", color: "#e2e8f0" },
    baslik:       { fontSize: 20, fontWeight: 600, marginBottom: "0.5rem", color: "#e2e8f0" },
    altBaslik:    { fontSize: 13, color: "#94a3b8", marginBottom: "1.25rem", maxWidth: 820, lineHeight: 1.6 },
    filtreSatiri: { display: "flex", gap: "1rem", alignItems: "flex-end", flexWrap: "wrap",
                    background: "#1e293b", padding: "1.25rem", borderRadius: "12px",
                    marginBottom: "1rem", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" },
    filtreGrup:   { display: "flex", flexDirection: "column", gap: "4px" },
    etiket:       { fontSize: "12px", color: "#94a3b8", fontWeight: 500 },
    select:       { padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1px solid #475569",
                    fontSize: "14px", minWidth: "140px", cursor: "pointer", background: "#0f172a", color: "#e2e8f0" },
    yukleniyor:   { textAlign: "center", padding: "3rem", color: "#94a3b8", fontSize: 14 },
    bos:          { textAlign: "center", padding: "3rem", background: "#1e293b",
                    borderRadius: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", color: "#94a3b8" },
    tablo:        { width: "100%", borderCollapse: "collapse", fontSize: "13px",
                    background: "#1e293b", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", borderRadius: "8px", overflow: "hidden" },
    thead:        { background: "#0f172a" },
    th:           { padding: "0.6rem 0.8rem", color: "white", textAlign: "left", whiteSpace: "nowrap", fontSize: "12px" },
    td:           { padding: "0.5rem 0.8rem", borderBottom: "1px solid #334155", verticalAlign: "top", color: "#e2e8f0" },
    menuKutu:     { position: "absolute", top: "calc(100% + 4px)", right: 0, background: "#1e293b",
                    border: "1px solid #334155", borderRadius: 10,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.12)", zIndex: 100, minWidth: 210, overflow: "visible" },
    menuItem:     { display: "block", width: "100%", textAlign: "left", padding: "10px 14px",
                    border: "none", background: "none", fontSize: 13, borderBottom: "1px solid #334155", color: "#e2e8f0" },
    ozetSatir:    { display: "flex", alignItems: "stretch", gap: 16, marginBottom: 12,
                    flexWrap: "wrap" },
    ozetSayac:    { display: "flex", alignItems: "center", background: "#1e293b", borderRadius: 10,
                    padding: "12px 20px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    whiteSpace: "nowrap", alignSelf: "stretch", flexShrink: 0 },
    basariKutu:   { flex: 1, background: "#1e293b", borderRadius: 10,
                    padding: "12px 16px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" },
    basariBaslik: { fontSize: 12, fontWeight: 600, color: "#94a3b8",
                    marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.05em" },
    basariGrid:   { display: "flex", gap: 6, flexWrap: "wrap" },
    basariHucre:  { background: "#182234", borderRadius: 8, padding: "8px 12px",
                    textAlign: "center", minWidth: 72 },
    basariEtiket: { fontSize: 10, color: "#94a3b8", marginBottom: 4 },
    basariN:      { fontSize: 10, color: "#94a3b8", marginTop: 2 },
    overlay:      { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
                    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
    popup:        { background: "#1e293b", borderRadius: 12, padding: "1.5rem",
                    maxHeight: "80vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
                    border: "1px solid #334155", color: "#e2e8f0" },
    popupBaslik:  { margin: "0 0 0.75rem", fontSize: 16, color: "#93c5fd" },
    popupButonlar:{ display: "flex", gap: 8, marginTop: "1.25rem", justifyContent: "flex-end" },
    btnIptal:     { padding: "6px 16px", borderRadius: 8, border: "1px solid #475569",
                    background: "#1e293b", cursor: "pointer", fontSize: 13, color: "#94a3b8" },
    btnOnay:      { padding: "6px 16px", borderRadius: 8, border: "none",
                    color: "white", cursor: "pointer", fontSize: 13 },
};
